import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";

export class CodeProps {
  language?: string;
  value?: string;
}

export default ({ language = "plaintext", value = "" }: CodeProps) => {
  let lang = language;
  switch (language) {
    case "html":
      lang = "htmlbars";
      break;
  }
  return (
    <div className="w-100" style={{ margin: "20px 0" }}>
      <SyntaxHighlighter
        language={lang}
        showLineNumbers
        showInlineLineNumbers
        style={atomOneDark}
        wrapLines={true}
        customStyle={{ border: 0, padding: 25 }}
      >
        {value}
      </SyntaxHighlighter>
    </div>
  );
};
